export const mapDataForBackend = (data) => ({
  devices: data.sources?.map(item => ({
    id: item.value,
  })) || [],
});
